// Simplified function to get a cookie value by name
let getCookie = (name) => {
    let allCookies = decodeURIComponent(document.cookie).split(';');
    let prefix = name + "=";
    for (let cookie of allCookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(prefix)) {
            return cookie.substring(prefix.length);
        }
    }
    return "";
}

// Function to check login status and redirect accordingly
let checkLoginAndRedirect = () => {
    if (!navigator.cookieEnabled) {
        alert("Enable Cookie to Continue...");
        return;
    }

    let isUserLogged = getCookie('userLogged') === 'true';
    let isAdminLogged = getCookie('accessToken') !== "";
    let currentUrl = window.location.href;
    let originUrl = window.location.origin;
    let currentPage = window.location.pathname;
    let urlParams = new URLSearchParams(window.location.search);
    let isRedirect = urlParams.get('redirect') === 'true';
    let redirectUrl = urlParams.get('url');

    // Store redirect URL if user is not logged in
    if (!isUserLogged && isRedirect && redirectUrl) {
        localStorage.setItem('redirectAfterLogin', redirectUrl);
        location.assign(`${originUrl}/`); // Redirect to login page
        return;
    }

    // Handle redirection after login
    if (isUserLogged) {
        alert("You are logged in");
        let redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
        if (redirectAfterLogin) {
            localStorage.removeItem('redirectAfterLogin'); // Clear the stored URL
            location.assign(redirectAfterLogin); // Redirect to the stored URL
            return;
        } else {
            if(isRedirect) {
                location.assign(`${redirectUrl}/`);
                return;
            }
        }
    }

    // Default redirection logic for logged in users
    if (currentPage === '/' && isUserLogged) {
        // alert("You are logged in");
        location.assign(`${originUrl}/dashboard.html`);
    }

    // Admin access logic
    document.onreadystatechange = () => {
        if (document.readyState === 'complete' && isAdminLogged) {
            console.log("Admin access");
            document.getElementById("addPlaceAdminTab").style.display = "block";
        }
    };
}

checkLoginAndRedirect();

